import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13;

import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import styled from '@xstyled/styled-components';
import { Space, Form, Modal, Input, Button, Tooltip, Popover } from 'antd';
import { TextLinkButton, NumberInput, TransparentButton, SingleSelectInput, PrimaryButton, SecondaryButton } from '@lib/common';
import { DeleteOutlined, PlusOutlined, EditOutlined, PlusCircleOutlined, MoreOutlined, DashOutlined } from '@ant-design/icons';
import { styleVariables } from '@lib/common';
import { RichTextEditor } from '../../rich-text-editor';
import { QuestionFieldType } from '@module/form';
import { questionTypeOptions } from '../../question-form';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var EXPLANATION = 'explanation';
var TextArea = Input.TextArea;
var Container = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  padding: 25px 35px;\n  border-radius: 8px;\n  background: ", ";\n  overflow: hidden;\n  border: 1px solid ", ";\n\n  @media (max-height: ", "px) {\n    font-size: 0.725rem;\n  }\n\n  * > .ant-form-item {\n    margin-bottom: 0;\n  }\n"])), styleVariables.colors.gray1, styleVariables.colors.blue4, styleVariables.responsive.tablet);
var ExplanationField = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
var QuestionHeaderContainer = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n"])));
var QuestionHeader = styled(Space)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var QuestionContentTitle = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  font-size: 1rem;\n  font-weight: 600;\n  margin-bottom: 8px;\n"])));
var QuestionExplanationLabel = styled.label(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  font-size: 14px;\n  font-weight: 600;\n  color: ", ";\n"])), styleVariables.colors.gray11);
var QuestionContentContainer = styled(Space)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: inherit;\n\n  .ant-form-item {\n    margin-bottom: 0;\n  }\n"])));
var StyledQuestionTypeSelect = styled(SingleSelectInput)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  min-width: 165px;\n"])));
var ExplanationLabelContainer = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var ExplanationTextArea = styled(TextArea)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  width: 100%;\n  margin-top: 16px;\n"])));
var ExplanationContent = styled(Input)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  text-overflow: ellipsis;\n  background: ", ";\n  color: ", " !important;\n"])), styleVariables.colors.gray3, styleVariables.colors.gray11);
var UtilButton = styled(Button)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  border: none;\n\n  &:hover {\n    color: ", ";\n  }\n"])), styleVariables.colors.blue3);
var StyledTextLinkButton = styled(TextLinkButton)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 500;\n  line-height: 24px;\n"])), styleVariables.colors.blue4);
export var BaseQuestionEdit = function BaseQuestionEdit(props) {
  var form = props.form,
      question = props.question,
      onDelete = props.onDelete,
      children = props.children,
      onUpdateExplanation = props.onUpdateExplanation,
      onUpdate = props.onUpdate,
      defaultDescription = props.defaultDescription,
      onShowingUploadQuestionFileModal = props.onShowingUploadQuestionFileModal,
      onDeleteQuestionFile = props.onDeleteQuestionFile,
      onCreateQuestion = props.onCreateQuestion,
      onSplitSection = props.onSplitSection,
      onUploadImage = props.onUploadImage,
      createQuestionFileStatus = props.createQuestionFileStatus,
      file = props.file;

  var _useState = useState(false),
      isExplanationModalVisible = _useState[0],
      setExplanationModalVisibility = _useState[1];

  var _useState2 = useState(question.explanation && question.explanation.trim() !== '' && question.explanation.trim() !== '<p><br></p>'),
      isExplanationOptionVisible = _useState2[0],
      setExplanationOptionVisibility = _useState2[1];

  var editorRef = useRef(null);

  var isRawHTMLEmpty = function isRawHTMLEmpty(rawHtml) {
    var excludeText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    if (false || !rawHtml) return true;
    var excludeTextWithoutWhitespace = excludeText.replace(/\s/g, '');
    var rawHtmlWithoutWhitespace = rawHtml.replace(/\s/g, '');
    var div = document.createElement('div');
    div.innerHTML = rawHtmlWithoutWhitespace;
    var text = div.textContent || div.innerText || '';

    if (text === excludeTextWithoutWhitespace) {
      return true;
    }

    return !text;
  };

  var handleOpenModal = useCallback(function () {
    setExplanationModalVisibility(true);
  }, []);
  var handleCloseModal = useCallback(function () {
    setExplanationModalVisibility(false);
    form.resetFields();
  }, [form]);
  var moreContent = useMemo(function () {
    return /*#__PURE__*/_jsxs(Space, {
      direction: "vertical",
      children: [/*#__PURE__*/_jsx(StyledTextLinkButton, {
        onClick: function onClick() {
          return onCreateQuestion(question.previousQuestionId);
        },
        icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
        children: "Th\xEAm c\xE2u h\u1ECFi b\xEAn tr\xEAn"
      }), /*#__PURE__*/_jsx(StyledTextLinkButton, {
        onClick: function onClick() {
          return onCreateQuestion(question.id.toString());
        },
        icon: /*#__PURE__*/_jsx(PlusCircleOutlined, {}),
        children: "Th\xEAm c\xE2u h\u1ECFi b\xEAn d\u01B0\u1EDBi"
      }), /*#__PURE__*/_jsx(StyledTextLinkButton, {
        onClick: function onClick() {
          return onSplitSection(question.id.toString());
        },
        icon: /*#__PURE__*/_jsx(DashOutlined, {}),
        children: "T\xE1ch ph\u1EA7n"
      })]
    });
  }, [onCreateQuestion, question.previousQuestionId, question.id, onSplitSection]);
  var renderExplainField = useCallback(function () {
    if (isExplanationOptionVisible) {
      return /*#__PURE__*/_jsxs(QuestionContentContainer, {
        children: [/*#__PURE__*/_jsxs(ExplanationLabelContainer, {
          children: [/*#__PURE__*/_jsx(QuestionExplanationLabel, {
            children: "Gi\u1EA3i th\xEDch"
          }), /*#__PURE__*/_jsx(Tooltip, {
            title: "Ch\u1EC9nh s\u1EEDa",
            placement: "top",
            children: /*#__PURE__*/_jsx(UtilButton, {
              size: "small",
              icon: /*#__PURE__*/_jsx(EditOutlined, {}),
              onClick: handleOpenModal
            })
          })]
        }), /*#__PURE__*/_jsx(ExplanationContent, {
          disabled: true,
          value: question.explanation
        })]
      });
    }

    return /*#__PURE__*/_jsx(TransparentButton, {
      size: "middle",
      icon: /*#__PURE__*/_jsx(PlusOutlined, {}),
      onClick: handleOpenModal,
      children: /*#__PURE__*/_jsx(_Fragment, {
        children: "Th\xEAm gi\u1EA3i th\xEDch"
      })
    });
  }, [isExplanationOptionVisible, handleOpenModal, question.explanation]);

  var handleUpdateExplanationConfirmation = function handleUpdateExplanationConfirmation() {
    onUpdateExplanation(question.id.toString(), EXPLANATION, form.getFieldValue(EXPLANATION));
    setExplanationOptionVisibility(form.getFieldValue(EXPLANATION) && form.getFieldValue(EXPLANATION) !== '' && form.getFieldValue(EXPLANATION) !== '<p><br></p>');
    setExplanationModalVisibility(false);
  }; // update description


  var updateDefaultDescription = useCallback(function () {
    form.setFieldsValue({
      description: defaultDescription
    });
    onUpdate(question.id.toString(), QuestionFieldType.description, defaultDescription);
  }, [defaultDescription, form, onUpdate, question.id]);
  var createDefaultDescriptionFuncRef = useRef();
  useEffect(function () {
    var createDefaultDescription = function createDefaultDescription() {
      var initialDescription = form.getFieldValue(QuestionFieldType.description);
      var htmlTagRegex = /(<([^>]+)>)/gi;
      var contentWithoutWhitespace = initialDescription === null || initialDescription === void 0 ? void 0 : initialDescription.replace(/\s/g, '');
      var formattedContentWithoutHTML = contentWithoutWhitespace === null || contentWithoutWhitespace === void 0 ? void 0 : contentWithoutWhitespace.replaceAll(htmlTagRegex, '');

      if (!formattedContentWithoutHTML) {
        updateDefaultDescription();
      }
    };

    window.onunload = createDefaultDescription;
    createDefaultDescriptionFuncRef.current = createDefaultDescription;
    return function () {
      createDefaultDescriptionFuncRef.current && createDefaultDescriptionFuncRef.current();
      window.onunload = null;
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  var handleDescriptionInputFocus = function handleDescriptionInputFocus(selection) {
    var _editorRef$current;

    var editorValue = ((_editorRef$current = editorRef.current) === null || _editorRef$current === void 0 ? void 0 : _editorRef$current.value.toString()) || "<p>".concat(question.description, "</p>");

    if (selection.index === 0 && editorValue) {
      selection.index = editorValue.length + 2;

      if (editorRef.current) {
        var editor = editorRef.current.editor;
        editorRef.current.setEditorSelection(editor, selection);
      }
    }

    if (isRawHTMLEmpty(editorValue, defaultDescription)) {
      form.setFieldsValue({
        description: ''
      });
    }
  };

  var handleDescriptionInputBlur = function handleDescriptionInputBlur(selection, source) {
    var _editorRef$current2;

    var editorValue = (_editorRef$current2 = editorRef.current) === null || _editorRef$current2 === void 0 ? void 0 : _editorRef$current2.value.toString();
    if (source === 'silent') return;

    if (isRawHTMLEmpty(editorValue, defaultDescription)) {
      updateDefaultDescription();
    }
  };

  var _useState3 = useState(form.getFieldValue('description') || defaultDescription),
      content = _useState3[0],
      setContent = _useState3[1];

  var handleEditorChangeText = useCallback(function (value, delta, source) {
    setContent(value);
  }, []);

  var handleLinkInput = function handleLinkInput(link) {
    if (editorRef.current) {
      editorRef.current.focus();

      var _index = (editorRef.current.unprivilegedEditor.getSelection() || {}).index || editorRef.current.unprivilegedEditor.getLength() - 1;

      editorRef.current.getEditor().insertEmbed(_index, 'link', "<a href=".concat(link, ">").concat(link, "</a>"), 'user');
    }
  }; // add image on editor


  useEffect(function () {
    if (editorRef.current && createQuestionFileStatus === 2 && file) {
      var range = editorRef.current.getEditor().getSelection();
      editorRef.current.getEditor().insertEmbed(range.index, 'image', file.url);
    }
  }, [file, createQuestionFileStatus]);

  function saveToServer(file) {
    onUploadImage(question.id.toString(), file);
  }

  var importImageHandler = function importImageHandler() {
    var input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = function () {
      var file = input.files[0]; // file type is only image.

      if (/^image\//.test(file.type)) {
        saveToServer(file);
      } else {
        console.warn('You could only upload images.');
      }
    };
  };

  return /*#__PURE__*/_jsxs(Container, {
    direction: "vertical",
    size: "large",
    children: [/*#__PURE__*/_jsxs(QuestionHeaderContainer, {
      children: [/*#__PURE__*/_jsx(QuestionHeader, {
        children: /*#__PURE__*/_jsx(Form.Item, {
          name: 'type',
          children: /*#__PURE__*/_jsx(StyledQuestionTypeSelect, {
            options: questionTypeOptions,
            defaultValue: [question.type]
          })
        })
      }), /*#__PURE__*/_jsxs(QuestionHeader, {
        children: [/*#__PURE__*/_jsx(Form.Item, {
          name: "score",
          children: /*#__PURE__*/_jsx(NumberInput, {
            min: 0,
            step: "0.25",
            controls: true,
            defaultValue: question.score,
            addonAfter: "\u0111i\u1EC3m",
            disabled: question.isFillInBlankQuestion(),
            stringMode: true
          })
        }), /*#__PURE__*/_jsxs("div", {
          children: [/*#__PURE__*/_jsx(TextLinkButton, {
            onClick: onDelete,
            icon: /*#__PURE__*/_jsx(DeleteOutlined, {})
          }), /*#__PURE__*/_jsx(Popover, {
            content: moreContent,
            trigger: 'click',
            placement: "bottom",
            children: /*#__PURE__*/_jsx(Button, {
              size: "middle",
              icon: /*#__PURE__*/_jsx(MoreOutlined, {}),
              type: "text"
            })
          })]
        })]
      })]
    }), /*#__PURE__*/_jsxs(QuestionContentContainer, {
      children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
        children: "C\xE2u h\u1ECFi"
      }), /*#__PURE__*/_jsx(Form.Item, {
        name: 'description',
        children: /*#__PURE__*/_jsx(RichTextEditor, {
          id: "question-description-".concat(question.id.toString()),
          placeholder: defaultDescription,
          onFocus: handleDescriptionInputFocus,
          onBlur: handleDescriptionInputBlur,
          editorRef: editorRef,
          onShowingUploadModal: function onShowingUploadModal() {
            return onShowingUploadQuestionFileModal(question.id.toString());
          },
          hasImage: question.files.length > 0,
          onChange: handleEditorChangeText,
          onInputLink: handleLinkInput,
          value: content,
          questionId: question.id.toString(),
          onImageUpload: importImageHandler,
          shouldAutoFocus: true
        })
      })]
    }), children, renderExplainField(), /*#__PURE__*/_jsxs(Modal, {
      open: isExplanationModalVisible,
      onCancel: handleCloseModal,
      centered: true,
      footer: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SecondaryButton, {
          onClick: handleCloseModal,
          size: "middle",
          children: "Hu\u1EF7"
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          onClick: handleUpdateExplanationConfirmation,
          size: "middle",
          children: "X\xE1c nh\u1EADn"
        }), ","]
      }),
      children: [/*#__PURE__*/_jsx(QuestionContentTitle, {
        children: "Th\xEAm gi\u1EA3i th\xEDch "
      }), /*#__PURE__*/_jsx(ExplanationField, {
        children: /*#__PURE__*/_jsx(Form.Item, {
          name: 'explanation',
          children: /*#__PURE__*/_jsx(ExplanationTextArea, {
            placeholder: "Nh\u1EADp gi\u1EA3i th\xEDch cho c\xE2u h\u1ECFi",
            rows: 12
          })
        })
      })]
    })]
  }, question.id.toString());
};